module.exports = __webpack_public_path__ + "img/ytslp_pendle_eth-pendle.cc2eb7ee.png";